import { createSlice } from "@reduxjs/toolkit";
// utils
import axios from "../../utils/axios";

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: false,
  players: [],
  sqauds: [],
  fetchLoading: false,
  firstTeamFetchLoading: false,
  secondTeamFetchLoading: false,
  firstTeamSquads: null,
  secondTeamSquads: null,
};

const slice = createSlice({
  name: "squad",
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    stopLoading(state) {
      state.isLoading = false;
      state.fetchLoading = false;
    },

    // START LOADING
    fetchLoading(state) {
      state.fetchLoading = true;
    },

    startFirstTeamFetchLoading(state) {
      state.firstTeamFetchLoading = true;
    },

    startSecondTeamFetchLoading(state) {
      state.secondTeamFetchLoading = true;
    },
    // UPDATE EVENT
    updateSquadSuccess(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.sqauds = state.sqauds.map((squad) => {
        if (squad.id === action.payload.id) {
          return action.payload;
        }
        return squad;
      });
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.error = action.payload;
    },

    // GET PRODUCTS
    getSquadSuccess(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.sqauds = action.payload;
    },

    getFirstTeamSquadSuccess(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.firstTeamSquads = action.payload;
    },

    getSecondTeamSquadSuccess(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.secondTeamSquads = action.payload;
    },

    // GET PRODUCTS
    createSquadSuccess(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.sqauds = [...state.sqauds, action.payload];
    },

    // DELETE EVENT
    deleteSquadSuccess(state, action) {
      const squadId = action.payload;
      state.sqauds = state.sqauds.filter((team) => team.id !== squadId);
      state.isLoading = false;
      state.fetchLoading = false;
    },
  },
});

export default slice.reducer;

export function getSquads({ team_slug, season_id, limit = 50, page = 1 }) {
  return async (dispatch) => {
    dispatch(slice.actions.fetchLoading());
    try {
      const response = await axios.get(`squads`, {
        params: {
          season_id,
          team_slug,
          limit,
          page,
        },
      });
      dispatch(slice.actions.getSquadSuccess(response.data.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getFirstTeamSquads({ team_slug, season_id }) {
  return async (dispatch) => {
    dispatch(slice.actions.fetchLoading());
    try {
      const response = await axios.get(`squads`, {
        params: {
          team_slug,
          season_id,
        },
      });
      dispatch(
        slice.actions.getFirstTeamSquadSuccess(response.data.data.data[0])
      );
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getSecondTeamSquads({ team_slug, season_id }) {
  return async (dispatch) => {
    dispatch(slice.actions.fetchLoading());
    try {
      const response = await axios.get(`squads`, {
        params: {
          team_slug,
          season_id,
        },
      });
      dispatch(
        slice.actions.getSecondTeamSquadSuccess(response.data.data.data[0])
      );
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function createSquad({ data, enqueueSnackbar, navigate }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      await axios.post("squads", data);
      enqueueSnackbar("Squad Member is added successfully");
      navigate(-1);
    } catch (error) {
      enqueueSnackbar(error.message || "error creating squad", {
        variant: "error",
      });

      dispatch(slice.actions.hasError(error));
    }
  };
}

export function updateSquad({ data, id, enqueueSnackbar, navigate }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      await axios.patch(`squads/${id}`, data);
      // dispatch(slice.actions.createSquadSuccess(response.data.data));
      enqueueSnackbar("Squad member is updated successfully");
      navigate(-1);
    } catch (error) {
      enqueueSnackbar(error.message || "error creating squad", {
        variant: "error",
      });

      dispatch(slice.actions.hasError(error));
    }
  };
}

export function deleteSquadMember({ data, enqueueSnackbar, team_slug }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      await axios.delete(`squads/${data?.squad_id}/${data?.player_id}`, data);
      dispatch(slice.actions.stopLoading());
      // dispatch(slice.actions.createSquadSuccess(response.data.data));
      enqueueSnackbar("Member is deleted successfully");
      window.location.reload();
    } catch (error) {
      enqueueSnackbar(error.message || "error creating squad", {
        variant: "error",
      });

      dispatch(slice.actions.hasError(error));
    }
  };
}

export function updateTeam({ id, data, enqueueSnackbar, setOpenEdit }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post(`teams/${id}`, data);
      dispatch(slice.actions.updateSquadSuccess(response.data.data));
      enqueueSnackbar("Team is updated successfully");
      setOpenEdit(false);
    } catch (error) {
      enqueueSnackbar(error.message, {
        variant: "error",
      });

      dispatch(slice.actions.hasError(error));
    }
  };
}

export function deleteTeam({ id, enqueueSnackbar }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      await axios.delete(`teams/${id}`);
      dispatch(slice.actions.deleteSquadSuccess(id));
      enqueueSnackbar("Team is deleted successfully");
    } catch (error) {
      enqueueSnackbar(error.message, {
        variant: "error",
      });
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------
